/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 * @description Predictable array shuffler based on a seed
 */

// https://en.wikipedia.org/wiki/Xorshift
const xor = (seed: number) => {
  const baseSeeds = [123456789, 362436069, 521288629, 88675123]

  let [x, y, z, w] = baseSeeds

  const random = () => {
    const t = x ^ (x << 11)
    ;[x, y, z] = [y, z, w]
    w = w ^ (w >> 19) ^ (t ^ (t >> 8))
    return w / 0x7fffffff
  }
  ;[x, y, z, w] = baseSeeds.map((i) => i + seed)
  ;[x, y, z, w] = [0, 0, 0, 0].map(() => Math.round(random() * 1e16))

  return random
}

// https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
export const shuffleArray = <T>(array: readonly T[], seed: number): T[] => {
  let m = array.length
  let t, i
  const shuffled = array.slice()
  const random = xor(seed)

  while (m) {
    i = Math.floor(random() * m--)
    t = shuffled[m]
    shuffled[m] = shuffled[i]
    shuffled[i] = t
  }

  return shuffled
}
